import * as React from "react";
import { Grid, Card, CardMedia } from "@material-ui/core";
import styled from "styled-components";
import getUrl from "../functions/getUrl";
import { withRouter, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { IApplicationState } from "../store";
import { selectAuth } from "../store/auth/selectors";
import LockImg from "../img/Lock.png";
import ArrowImg from "../img/Arrow-01.png";
import Theme from "../Theme";
import { Link } from "react-router-dom";

const CardImg = styled(CardMedia)`
  height: 140px;
`;

const Lock = styled.div`
  margin: 0 10px;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  user-select: none;

  & img {
    width: 0.75em;
    height: 1em;
  }
`;

const Details = styled(Grid)`
  padding: 0.5em;
  height: 85px;
  font-size: 18px;
  color: ${Theme.colors.blackText};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BottomLinkWrapper = styled(Grid)`
  font-size: 18px;
  background-color: #f2f2f2;
  transition: background-color 0.2s ease-out;
  :hover {
    background-color: ${Theme.colors.lightBackgroundHover};
  }
`;

const BottomLink = styled(Link)`
  padding: 0.5em;
  width: 100%;
  height: 100%;
  color: ${Theme.colors.blackText};
  text-decoration: none;
  display: flex;
`;

const BottomAnchor = styled.a`
  padding: 0.5em;
  width: 100%;
  height: 100%;
  color: ${Theme.colors.blackText};
  text-decoration: none;
  display: flex;
`;

const Arrow = styled.img`
  width: 40px;
  height: 10px;
`;

const ArrowContainer = styled(Grid)`
  text-align: center;
`;

export interface IFeatureCardProps extends RouteComponentProps {
  image: string;
  imageAlt: string;
  loggedOutDescription?: string;
  description: string;
  to: string;
  children: React.ReactNode;
  isAuthenticated: boolean;
  isLocked?: boolean;
  isExternalLink?: boolean;
}

function FeatureCard(props: IFeatureCardProps) {
  const { to, image, description, loggedOutDescription, isLocked, isAuthenticated, isExternalLink, children } = props;

  const isLoggedOut = isLocked && !isAuthenticated;
  const path = isLoggedOut ? "/apply" : to;
  const title = isLoggedOut && loggedOutDescription ? loggedOutDescription : description;

  const linkChildren = (
    <>
      <ArrowContainer item xs={2}>
        <Arrow src={ArrowImg} />
      </ArrowContainer>
      <Grid item xs={10}>
        {title}
      </Grid>
    </>
  );

  return (
    <Grid item xs={12} lg={6}>
      <Card>
        <CardImg image={getUrl(image)} title={title} />
        <Details item>
          <Grid item xs={1}>
            {isLoggedOut && (
              <Lock>
                <img src={LockImg} />
              </Lock>
            )}
          </Grid>
          <Grid item xs={11}>
            {children}
          </Grid>
        </Details>
        <BottomLinkWrapper item>
          {isExternalLink && !isLoggedOut ? (
            <BottomAnchor href={path} target="_blank" rel="noopener noreferrer">
              {linkChildren}
            </BottomAnchor>
          ) : (
            <BottomLink to={path}>{linkChildren}</BottomLink>
          )}
        </BottomLinkWrapper>
      </Card>
    </Grid>
  );
}

export default connect((state: IApplicationState) => {
  return selectAuth(state);
})(withRouter(FeatureCard));
